import React from 'react'
import strings from 'mobile_web/strings'
import './styles.less'

interface Props {
	onClick: React.MouseEventHandler<HTMLDivElement>
	isFavourited: boolean
	favoritesEnabled: boolean
}
export const ItemFavouriteButton: React.FC<Props> = ({ onClick, isFavourited, favoritesEnabled }) => {
	const icon = isFavourited ? 'fas fa-heart' : 'fal fa-heart'
	const label = isFavourited ? strings.unfavourite : strings.favourite
	if (!favoritesEnabled) {
		return null
	}
	return (
		<div className="item-favourite-button-container" onClick={onClick}>
			<i className={icon} aria-label={label} />
		</div>
	)
}
